import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { LoadingContext, M_Table, NavigateContext } from 'src/M_Components'

export const EquipmentLeasingList = ({ roles }) => {
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)

    const newRoute = (url, operation, label, row) => {
        if (operation === 'Edit' || operation === 'Copy') {
            if (row) {
                sessionStorage.setItem('editingEquipmentLeasing', JSON.stringify(row))
                sessionStorage.setItem('operationType', operation)  
            } else {
                return
            }
        }
        if (operation === 'Create') ctx.setPassValues({ Operation: operation })
        ctx2.newTab(url, label)
    }

    return (
        <M_Table
            entityName={'EquipmentLeasing'}
            api='secondary'
            showTitle={true}
            title={'Equipment Conditions'} 
            roleName={'usersGroups'}
            rolePermissions={roles}
            replaceFunctions={new Map([
                ['Create', (row) => newRoute('containerControl/equipmentLeasingCrud', 'Create', t('Add')+' '+t('Equipment')+' '+ t('Leasing'), row)],
                ['Edit', (row) => newRoute('containerControl/equipmentLeasingCrud', 'Edit',t('Edit')+' '+t('Equipment')+' '+ t('Leasing'), row)],
                ['Copy', (row) => newRoute('containerControl/equipmentLeasingCrud', 'Copy', t('Copy')+' '+t('Equipment')+' '+ t('Leasing'), row)]
            ])}
        />
    )
}